import { Controller } from "stimulus";

export default class extends Controller {
  connect() {
    this.element.addEventListener(
      'promote:favorites-changed', this.handleFavoriteChanged.bind(this)
    );
  }

  disconnect() {
    this.element.removeEventListener(
      'promote:favorites-changed', this.handleFavoriteChanged.bind(this)
    );
  }

  handleFavoriteChanged(event) {
    const favorited = event.detail.favorited;
    const favoritableId = event.detail.favoritable_id;
    const favoriteId = event.detail.favorite_id;

    this._updateTabContent();
    this._updateFavoritesBadgeCount(favorited);
    this._updateAllProgramInstances(favoritableId, favorited, favoriteId);
  }

  _updateFavoritesBadgeCount(favorited) {
    const favoritesTab = this.element.querySelector(
      '[data-programs-badge-counter-favorites-badge-target="favoritesBadge"]'
    );

    const badgeElement = favoritesTab.querySelector('[data-test-badge-right] .badge');

    let currentCount = parseInt(badgeElement.textContent) || 0;

    const newCount = favorited ? currentCount + 1 : Math.max(0, currentCount - 1);

    badgeElement.textContent = newCount;
  }

  _updateTabContent() {
    const favoritesTabContent = document.querySelector('[data-content-id="programs-favorites"]');

    favoritesTabContent.dataset.contentLoaderLoaded = 'false';
  }

  _updateAllProgramInstances(favoritableId, favorited, favoriteId) {
    // Find all elements with the same favoritable ID across all tabs
    const allProgramElements = document.querySelectorAll(
      `[data-favorites-favoritable-id-value="${favoritableId}"]`
    );

    allProgramElements.forEach(element => {
      // Update favorite ID attribute
      if (favorited && favoriteId) {
        element.setAttribute('data-favorites-favorite-id-value', favoriteId);
      } else {
        element.setAttribute('data-favorites-favorite-id-value', '');
      }

      // Update icon
      const iconElement = element.querySelector('[data-favorites-target="icon"]');
      if (iconElement) {
        const newIcon = favorited ? 'star-filled' : 'star';
        iconElement.setAttribute('data-test-icon', newIcon);

        const svgElement = iconElement.querySelector('svg');
        if (svgElement) {
          const pathElement = svgElement.querySelector('path');
          if (pathElement) {
            if (favorited) {
              pathElement.setAttribute('fill', '#832088');
            } else {
              pathElement.removeAttribute('fill');
            }
          }
        }
      }

      // Update title/tooltip
      const favoriteText = element.getAttribute('data-favorites-favorite-text-value');
      const unfavoriteText = element.getAttribute('data-favorites-unfavorite-text-value');
      element.setAttribute('title', favorited ? unfavoriteText : favoriteText);
    });
  }
}
